import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { useReducer, useState } from 'react'
import dashboardApi from 'services/api/dashboard'

import styles from './AddHotelGroup.module.scss'

const initialState = {
  name: '',
  address: '',
  url: '',
  termsUrl: '',
  privacyUrl: ''
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'change':
      return { ...state, [action.name]: action.value }
    default:
      return state
  }
}

const AddHotelGroupModal = ({ closeModal, addHotelToList, switchToHotel }) => {
  const [hotelInfo, dispatchInfo] = useReducer(reducer, initialState)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState(false)

  const handleConfirm = async e => {
    e.preventDefault()
    await dashboardApi
      .addHotelGroup({
        ...hotelInfo,
        termsUrl: hotelInfo.termsUrl.length > 0 ? hotelInfo.termsUrl : null,
        privacyUrl: hotelInfo.privacyUrl.length > 0 ? hotelInfo.privacyUrl : null,
        url: hotelInfo.url.length > 0 ? hotelInfo.url : null
      })
      .then(data => {
        if (addHotelToList) {
          addHotelToList(data)
        }
        switchToHotel(data.id)
        closeModal()
      })
      .catch(err => {
        setError(true)
        setErrorMessage(err.message)
      })
  }

  return (
    <ConfirmationDialog
      title="Add a hotel group"
      positiveMessage="Save group"
      negativeMessage="Cancel"
      theme="blacklist"
      onConfirm={handleConfirm}
      onClose={closeModal}
    >
      <div className={styles.form}>
        <TextInput
          onChange={e =>
            dispatchInfo({
              type: 'change',
              name: e.target.name,
              value: e.target.value
            })
          }
          name="name"
          value={hotelInfo.name}
          label="Group name"
          isFullWidth
          required
        />
        <TextInput
          onChange={e =>
            dispatchInfo({
              type: 'change',
              name: e.target.name,
              value: e.target.value
            })
          }
          name="url"
          value={hotelInfo.url}
          label="Website URL"
          isFullWidth
        />
        <TextInput
          onChange={e =>
            dispatchInfo({
              type: 'change',
              name: e.target.name,
              value: e.target.value
            })
          }
          name="termsUrl"
          value={hotelInfo.termsUrl}
          label="Terms URL"
          isFullWidth
        />
        <TextInput
          onChange={e =>
            dispatchInfo({
              type: 'change',
              name: e.target.name,
              value: e.target.value
            })
          }
          name="privacyUrl"
          value={hotelInfo.privacyUrl}
          label="Privacy URL"
          isFullWidth
        />
        <TextInput
          onChange={e =>
            dispatchInfo({
              type: 'change',
              name: e.target.name,
              value: e.target.value
            })
          }
          name="address"
          value={hotelInfo.address}
          label="Physical address"
          isFullWidth
          required
        />
        {error && (
          <div className={styles.error}>
            <p>{errorMessage || 'something went wrong'}</p>
            <p>please try again</p>
          </div>
        )}
      </div>
    </ConfirmationDialog>
  )
}

export default AddHotelGroupModal
